import { DialogContent } from "@mui/material";
import { StyledCheckBox } from "./BuildlingBlocks/StyledCheckbox";
import { useState } from "react";
import { StyledFormControlLabel } from "./BuildlingBlocks/StyledFormControlLabel";
import { UIStandardLayer } from "./BuildlingBlocks/UIStandardLayer";
import { UILabel } from "./BuildlingBlocks/UILabel";

export function ConfirmDialog(props: {
    onConfirm: (dontAskAgain?: boolean) => void;
    onCancel: () => void;
    caption?: string;
    action?: string;
    open: boolean;
    hideDoNotAskAgain?: boolean;
}) {
    const [dontAskAgain, setDontAskAgain] = useState<boolean>(false);

    return (
        <UIStandardLayer
            open={props.open}
            onClose={props.onCancel}
            onPrimaryAction={() => {
                props.onConfirm(dontAskAgain);
            }}
            title={"Confirm  " + (props.action ?? "delete") + " " + (props.caption ?? "this")}
            primaryActionText={"Yes"}
            onSecondaryAction={() => {
                props.onCancel();
            }}
            secondaryActionText={"Cancel"}
            renderUI={() => {
                return (
                    <DialogContent>
                        <UILabel>
                            Are you sure to want to {props.action || "delete"} {props.caption || "this"}?
                        </UILabel>
                        {!props.hideDoNotAskAgain && (
                            <StyledFormControlLabel
                                label={"Don't Ask Again?"}
                                control={
                                    <StyledCheckBox
                                        checked={dontAskAgain}
                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                                            setDontAskAgain(event.target.checked)
                                        }
                                    />
                                }
                            />
                        )}
                    </DialogContent>
                );
            }}
        />
    );
}
